module.exports = __webpack_public_path__ + "@/assets/img/procedures-header.85bf8a39.png";